module.exports = __webpack_public_path__ + "img/logo-light2.aea676bf.png";